function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { useLayoutEffect } from "../useLayoutEffect";
import { useCallback, useState } from "react";
import useResizeObserver from "./useResizeObserver";
var useResize = function(target, options) {
    var ref2 = options || {}, isVertical = ref2.isVertical, isContentBox = ref2.isContentBox;
    var ref1 = _slicedToArray(useState({}), 2), size = ref1[0], setSize = ref1[1];
    var callback = useCallback(function(entries) {
        return entries.forEach(function(entry) {
            var box = isContentBox ? entry.contentBoxSize : entry.borderBoxSize;
            var ref = (box === null || box === void 0 ? void 0 : box[0]) || {}, blockSize = ref.blockSize, inlineSize = ref.inlineSize;
            setSize({
                width: isVertical ? blockSize : inlineSize,
                height: isVertical ? inlineSize : blockSize
            });
        });
    }, [
        isContentBox,
        isVertical
    ]);
    useLayoutEffect(function() {
        if (target && target.current) {
            var ref = target.current.getBoundingClientRect(), width = ref.width, height = ref.height;
            setSize({
                width: width,
                height: height
            });
        }
    }, [
        target
    ]);
    useResizeObserver({
        target: target,
        callback: callback
    });
    return size;
};
export default useResize;
